import { DecimalFormat } from "@omni/types/components/price/enums/decimalFormat.enum";
import { strikeThrough } from "@omni/ui/components/Price//components/strikeThrough.style";
import { conversion } from "@omni/ui/components/Price/components/conversion.style";
import { main } from "@omni/ui/components/Price/components/main.style";
import { PriceStyleTokens } from "@omni/ui/components/Price/price.tokens";
import { tv } from "tailwind-variants";

const base = tv({
    base: ["tw:flex tw:flex-col tw:w-fit tw:items-end tw:p-px"]
});

export const PriceStyle = Object.assign(base, {
    main: main,
    conversion: conversion,
    strikeThrough: strikeThrough,
    decimalFormat: DecimalFormat.Hidden
}) satisfies PriceStyleTokens;
